import TableNotification from './tableNotification';

export default TableNotification;
